var map = {
	"./music-instructions.json": 4577,
	"./music-library-intro2024.json": 4578,
	"./music-library-launch2024.json": 4579,
	"./music-progression.json": 4580,
	"./startSourcesAdvanced.json": 4581,
	"./startSourcesSimple.json": 4582,
	"./startSourcesSimple2.json": 4583,
	"./startSourcesTracks.json": 4584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4348;